// fetchCountries.js
import { message } from "antd";
import { token } from "../../constants/Constants";
import { getAllPincodes } from "../../endpoints/API";
// import { useSelector } from "react-redux";

export const fetchPincode = async (setPincode, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await getAllPincodes();
    if (response.statusText=="OK") {
      const data = response?.data;
      setPincode(data); // Update state with fetched countries
    } else {
      message.error("Failed to fetch pincodes.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching pincodes.");
  }
};
